export default "__VITE_ASSET__67d4fff1__"